export default __webpack_public_path__ + "static/media/vehicle.8711dde2.png";